import msalInstance from "./msalInstance";
import { apiScopeConfig, loginRequest } from "./msalConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const authService = {
    login: async () => {
        try {
            const loginResponse = await msalInstance.loginPopup(loginRequest);
            msalInstance.setActiveAccount(loginResponse.account);
            // ✅ Force reload so app state reinitializes properly
            window.location.reload();
            return loginResponse;
        } catch (error) {
            console.error(error);
        }
    },

    //   Logs out the current user.
    logout: () => {
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount) {
            msalInstance.logoutRedirect();
        }
    },

    // Sets the active account from the list of cached accounts.
    setActiveAccount: () => {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    },

   //Acquires a token silently for API access.
    getToken: async () => {
        const activeAccount = msalInstance.getActiveAccount();

        if (!activeAccount) {
            throw new Error("No active account! User must sign in.");
        }
        const requesObj = {
            loginRequest,
            account: activeAccount,
            scopes: apiScopeConfig.apiScope,
        };

        try {
            const response = await msalInstance.acquireTokenSilent(requesObj);
            return response.accessToken;
        } catch (error) {
            console.error("Token acquisition failed:", error);        

            if (error instanceof InteractionRequiredAuthError) {
                try {
                    const popupResponse = await msalInstance.acquireTokenPopup(requesObj);
                    console.log("Token acquired interactively");
                    msalInstance.setActiveAccount(popupResponse.account);

                    window.location.reload();
                    return popupResponse.accessToken;
                } catch (popupError) {
                    console.error("Interactive token acquisition failed:", popupError);
                }
            }
        }
    },
};

export default authService;